import Vue from 'vue';

/** Event bus for sending integrations events. */
const IntegrationsEventBus = new Vue();

export default IntegrationsEventBus;
